export default __webpack_public_path__ + "static/home-slide-small002-ab8ea2b5b1e3b2243af90bfa54637d39.jpg";